import { UserSection } from 'common/components/UsersActionsContainer/types'
import { MIN_SEARCH_LENGTH } from 'features/Contacts/Network/constants'

export const isSearchStringValid = (value: string) => value?.trim()?.length >= MIN_SEARCH_LENGTH

export const getGlobalSearchQueryParams = (sections: UserSection[], searchString?: string) => {
  const excludeUids = new Set<string>()
  let limit: number | undefined
  let showGlobalSearchData = false

  sections?.forEach((section) => {
    if (section.enableGlobalSearch && searchString && isSearchStringValid(searchString)) {
      showGlobalSearchData = true
      limit = section.usersLimit
    }

    if (!section.enableGlobalSearch && section.users) {
      section.users.forEach((user) => excludeUids.add(user.uid))
    }
  })

  return { excludeUids, limit, showGlobalSearchData }
}

export const calculateSectionUsersLength = (sections: UserSection[]) => {
  return sections.reduce((acc, section) => acc + (section.users?.length || 0), 0)
}

export const isSectionsEmpty = (sections: UserSection[]) => {
  return !sections?.some((section) => section.users?.length)
}
